import React from 'react'
import RichtextParser from '../../../utils/richtext-parser'
import parseStoryblokLink from '../../../utils/parse-storyblok-link'
import SectionTitleAndButton from '../../section-title-and-button'

interface StoryblokCtaWithTextblockAdapterProps {
  text?: string | Record<any, any>;
  ctaText: string;
  ctaLink: Record<any, any>;
  ctaType?: 'download' | 'link';
  ctaFile: Record<any, any>;
  popupTitle: string | Record<any, any>;
}

function StoryblokCtaWithTextblockAdapter({
  text,
  ctaText,
  ctaLink,
  ctaType,
  ctaFile,
  popupTitle
}: StoryblokCtaWithTextblockAdapterProps) {
  if (ctaType === 'download') {
    return (
      <SectionTitleAndButton
        text={text}
        subtitle={''}
        download
        filePath={ctaFile && ctaFile.filename}
        popupTitle={RichtextParser(popupTitle)}
        button={{
          children: ctaText
        }}
        grey
      />
    )
  } else if (ctaType === 'link') {
    return (
      <SectionTitleAndButton
        text={text}
        subtitle={''}
        button={{
          children: ctaText,
          to: parseStoryblokLink(ctaLink)
        }}
        grey
      />
    )
  } else {
    return <div></div>
  }
}

export default StoryblokCtaWithTextblockAdapter
